import { Component, inject } from '@angular/core';
import { TaskDetailsViewSettingsService } from '@app/components/task/task-splitview-list/task-details-content/task-details-view-settings.service';
import {
  TaskViewGroupChange,
  TaskViewSettingChange,
  TaskViewSettingSection,
  TaskViewSettingsComponent
} from '@app/components/task/task-view-settings/task-view-settings.component';

const TASK_DETAILS_VIEW_SETTINGS_SECTIONS: readonly TaskViewSettingSection[] = [
  {
    kind: 'toggles',
    key: 'task-data',
    labelKey: 'task-filters.sections.taskData',
    toggleable: true,
    options: [
      { key: 'status', labelKey: 'project-tasks.list.column-headers.status' },
      { key: 'progress', labelKey: 'project-tasks.list.column-headers.progress' },
      { key: 'priority', labelKey: 'project-tasks.list.column-headers.priority' }
    ]
  },
  {
    kind: 'toggles',
    key: 'location',
    labelKey: 'task-list-group-location',
    toggleable: true,
    options: [
      { key: 'industry', labelKey: 'project-tasks.list.column-headers.industry' },
      { key: 'location', labelKey: 'project-tasks.list.column-headers.location' }
    ]
  },
  {
    kind: 'toggles',
    key: 'totalHours',
    labelKey: 'project-tasks.list.column-headers.total-hours',
    toggleable: true,
    options: []
  },
  {
    kind: 'toggles',
    key: 'dates',
    labelKey: 'task-filters.sections.dates',
    toggleable: true,
    options: [
      { key: 'startDate', labelKey: 'project-tasks.list.column-headers.start-date' },
      { key: 'endDate', labelKey: 'project-tasks.list.column-headers.end-date' }
    ]
  },
  {
    kind: 'toggles',
    key: 'estimation',
    labelKey: 'estimation',
    toggleable: true,
    options: [
      { key: 'estimationTime', labelKey: 'project-tasks.list.column-headers.estimated-time' },
      { key: 'estimationCost', labelKey: 'project-tasks.list.column-headers.estimated-cost' },
      { key: 'estimationQuantity', labelKey: 'task-details-view-settings.quantity' }
    ]
  },
  {
    kind: 'toggles',
    key: 'users',
    labelKey: 'task-filters.sections.users',
    toggleable: true,
    options: []
  },
  {
    kind: 'toggles',
    key: 'tags',
    labelKey: 'project-tasks.list.column-headers.tags',
    toggleable: true,
    options: []
  },
  {
    kind: 'toggles',
    key: 'acknowledgement',
    labelKey: 'task-description-acknowledgement-panel.title',
    toggleable: true,
    options: []
  }
];

/**
 * PROPOZYCJA — DO WERYFIKACJI: details adapter for the shared view-settings control.
 * Owns no list-filter state; title, type and number stay outside this menu.
 * @summary Configures optional editable fields in mobile task details.
 * @selector proffeo-task-details-view-settings
 */
@Component({
  selector: 'proffeo-task-details-view-settings',
  templateUrl: './task-details-view-settings.component.html',
  host: { class: 'inline-flex shrink-0' },
  imports: [TaskViewSettingsComponent]
})
export class TaskDetailsViewSettingsComponent {
  private readonly settings = inject(TaskDetailsViewSettingsService);

  protected readonly sections = TASK_DETAILS_VIEW_SETTINGS_SECTIONS;
  protected readonly values = this.settings.values;
  protected readonly groupEnabled = this.settings.groupEnabled;

  protected updateSetting(change: TaskViewSettingChange): void {
    this.settings.applyChange(change);
  }

  protected toggleGroup(change: TaskViewGroupChange): void {
    this.settings.applyGroup(change);
  }
}
